export default function stickyNavigation (document, moduleHTML, appEventEmitter) {
  let firstSectionVisible = true
  let previousSection = null
  const stickyNav = moduleHTML
  // Deconstructing the NodeList into an array for .map()
  // Only grabs anchor tags from sticky navigation
  const links = [...document.querySelectorAll('a[data-js-sticky-navigation-links]')]
  const sections = links.map(link => {
    const id = link.getAttribute('href')
    return document.querySelector(id)
  })

  const setupIntersectionObserver = () => {
    const stickyNavObserver = new window.IntersectionObserver(
      elements => {
        firstSectionVisible = elements[0].isIntersecting
        stickyNav.classList.toggle('md-lg:hidden', firstSectionVisible)
        stickyNav.classList.toggle('md-lg:flex', !firstSectionVisible)
      },
      {
        root: null, // Document viewport
        rootMargin: '-1px', // 1px margin helps with onClick events
        threshold: 0 // When user scrolls past the hero
      }
    )

    const boldObserver = new window.IntersectionObserver(
      elements => {
        elements.forEach(element => {
          const href = `#${element.target.getAttribute('id')}`
          const link = links.find(link => link.getAttribute('href') === href)

          if (element.isIntersecting) {
            link.classList.add('is-visible')
            previousSection = element.target.getAttribute('id')
          } else {
            link.classList.remove('is-visible')
          }

          const firstVisibleLink = stickyNav.querySelector('a.is-visible')

          links.forEach(link => {
            link.classList.remove('font-bold')
          })

          if (firstVisibleLink) {
            firstVisibleLink.classList.add('font-bold')
          }

          if (!firstVisibleLink && previousSection) {
            stickyNav.querySelector(
              `a[href="#${previousSection}"]`
            ).classList.add('font-bold')
          }
        })
      },
      {
        root: null, // Document viewport
        rootMargin: '-1px', // 1px margin helps with onClick events
        threshold: 0 // When user scrolls past the beginning of the section
      }
    )
    // Use first hero section as trigger
    stickyNavObserver.observe(document.querySelector('section[data-js-module-name*="-hero"]'))
    // Observe all ids listed in sticky navigation
    sections.forEach(section => {
      boldObserver.observe(section)
    })
  }

  if ('IntersectionObserver' in window) {
    setupIntersectionObserver()
  }
}
